import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router';
import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';
import BaseLayout from 'src/layouts/BaseLayout';
import SidebarLayout from './layouts/SidebarLayout';
import { useAppSelector } from './redux/root';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);

const Login = Loader(lazy(() => import('src/content/auth/Login')));

const ForgetPassword = Loader(
  lazy(() => import('src/content/auth/ForgetPassword'))
);

const DashboardAdmin = Loader(
  lazy(() => import('src/content/admin/dashboard/DashboardAdmin'))
);

const Admins = Loader(lazy(() => import('src/content/admin/user/Admins')));
const Users = Loader(lazy(() => import('src/content/admin/user/users')));
const Cotisations = Loader(
  lazy(() => import('src/content/admin/cotisation/Cotisation'))
);

const AppConfig = Loader(
  lazy(() => import('src/content/admin/app-config/AppConfig'))
);

const Khassida = Loader(
  lazy(() => import('src/content/admin/khassida/Khassida'))
);

const Salatou = Loader(lazy(() => import('src/content/admin/salatou/Salatou')));
const Campange = Loader(
  lazy(() => import('src/content/admin/campagne/Campange'))
);

const Azkaar = Loader(lazy(() => import('src/content/admin/azkaar/Azkaar')));

const AlQuran = Loader(
  lazy(() => import('src/content/admin/Al-quran/AlQuran'))
);

const Playlists = Loader(
  lazy(() => import('src/content/admin/playlist/Playlists'))
);

const Contacts = Loader(
  lazy(() => import('src/content/admin/contacts/Contacts'))
);

const Privacy = Loader(lazy(() => import('src/content/Privcacy')));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="login" replace />
      },
      {
        path: '/login',
        element: <GestElement element={Login} />
      },
      {
        path: '/forget-password',
        element: <GestElement element={ForgetPassword} />
      },
      {
        path: '/admin',
        element: <AdminElement element={SidebarLayout} />,
        children: [
          {
            path: '/admin',
            element: <Navigate to="/admin/dashboard" replace />
          },
          {
            path: '/admin/dashboard',
            element: <DashboardAdmin />
          },
          {
            path: '/admin/administrators',
            element: <Admins />
          },
          {
            path: '/admin/utilisateurs',
            element: <Users />
          },
          {
            path: '/admin/playlist',
            element: <Playlists />
          },
          {
            path: '/admin/settings',
            element: <AppConfig />
          },
          {
            path: '/admin/salatou',
            element: <Salatou />
          },
          {
            path: '/admin/campagne',
            element: <Campange />
          },
          {
            path: '/admin/khassida',
            element: <Khassida />
          },
          {
            path: '/admin/azkaar',
            element: <Azkaar />
          },
          {
            path: '/admin/al-quran',
            element: <AlQuran />
          },
          {
            path: '/admin/cotisations',
            element: <Cotisations />
          },

          {
            path: '/admin/contacts',
            element: <Contacts />
          }
        ]
      },
      {
        path: '/privacy',
        element: <Privacy />
      },

      {
        path: '404',
        element: <Status404 />
      },
      {
        path: '*',
        element: <Navigate to="404" replace />
      }
    ]
  }
];

export default routes;
function AdminElement({ element: Element, ...props }) {
  const { user, userInfos } = useAppSelector((s) => s.auth);
  if (userInfos?.isAdmin) {
    return <Element {...props} />;
  }
  if (user) return <Navigate to={'/404'} replace />;

  return <Navigate to={'/login'} replace />;
}

function GestElement({ element: Element, ...props }) {
  const user = useAppSelector((s) => s.auth.user);
  if (user?.uid) {
    return <Navigate to={'/admin/dashboard'} replace />;
  }
  return <Element {...props} />;
}
